import React, { useState } from 'react';
import FontAwesomeIcon from "@fortawesome/react-fontawesome"
import { ExpansionPanelSummary, ExpansionPanel, Typography, ExpansionPanelDetails } from 'material-ui';
import { faChevronDown } from "@fortawesome/fontawesome-free-solid"
import styled from 'styled-components'
import Container from 'modules/layout/components/Container';
import CounsellorExpanded from '../counsellor-expanded/CounsellorExpanded';
import "./counsellor.scss"
import LegendsList from './legend/LegendsList';



const Details = styled(ExpansionPanelDetails)`
  padding: 0 0 1rem 0;
`

const Summary = styled(ExpansionPanelSummary)`
  padding: 0 1rem;
  margin: 0 !important;
`

const CounsellorItem = ({counsellor}) => {
    const [expanded, setExpanded] = useState(false)

    const {name, clients, alerts} = counsellor

    const onChangeExpand = (e, exp) => {
        exp ? setExpanded(true) : setExpanded(false)
    }

    return (
        <ExpansionPanel 
            expanded={expanded} 
            onChange={onChangeExpand}
            className="counsellor-item"
        >
            <Summary expandIcon={<FontAwesomeIcon icon={faChevronDown} /> }>
              <Typography className="counsellor-collapsed" component={'span'}>
                {name}
                <LegendsList alerts={alerts}/>
              </Typography>
            </Summary>
            <Details>
              <Container>
                <CounsellorExpanded
                  clients={clients}
                />
              </Container>
            </Details>
          </ExpansionPanel>
    );
};

export default CounsellorItem;